import React, { Component } from 'react';
// import API from '../api.js';/
import { Spinner } from 'react-bootstrap';

export default class Loading extends Component {
    constructor() {
        super();
        // this.state = {
        //     isLoading: API.getIsLoading()
        // }
    }

    render() {
        // if (this.state.isLoading) {
        if (this.props.isLoading) {
            return (
                <div id="loading_container">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>
            )
        }
        return <></>;
    }
}